import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAP_EMBED =
  "https://maps.google.com/maps?q=Priceline%20Pharmacy%2C%20146%20Bussell%20Highway%2C%20Margaret%20River%20WA%206285&z=16&output=embed";
const DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=Priceline+Pharmacy+Margaret+River+146+Bussell+Highway+Margaret+River+WA+6285";

export default function ContactMap() {
  return (
    <section id="contact" data-testid="contact-section" className="scroll-mt-24 bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="mb-12 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-pink" data-testid="contact-eyebrow">Visit Us</p>
          <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight sm:text-4xl" data-testid="contact-heading">
            In the heart of Margaret River
          </h2>
        </div>

        <div className="grid gap-8 lg:grid-cols-12">
          <div className="flex flex-col justify-between rounded-3xl border border-border/60 bg-brand-cream p-8 lg:col-span-4" data-testid="contact-info-card">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin className="mt-0.5 h-6 w-6 shrink-0 text-brand-pink" />
                <div>
                  <p className="font-heading font-bold">Address</p>
                  <p className="mt-1 text-sm text-muted-foreground" data-testid="contact-address">
                    146 Bussell Highway<br />Margaret River WA 6285
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Phone className="mt-0.5 h-6 w-6 shrink-0 text-brand-pink" />
                <div>
                  <p className="font-heading font-bold">Phone</p>
                  <a href="tel:+61897572224" data-testid="contact-phone-link" className="mt-1 block text-sm font-semibold text-brand-pink hover:text-brand-pinkdark">
                    (08) 9757 2224
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Clock className="mt-0.5 h-6 w-6 shrink-0 text-brand-pink" />
                <div>
                  <p className="font-heading font-bold">Opening hours</p>
                  <p className="mt-1 text-sm text-muted-foreground">Monday – Sunday<br />8:00am – 6:00pm</p>
                </div>
              </div>
            </div>
            <Button
              asChild
              data-testid="contact-directions-btn"
              className="mt-8 w-full rounded-full bg-brand-pink py-6 font-heading font-semibold text-white hover:bg-brand-pinkdark"
            >
              <a href={DIRECTIONS} target="_blank" rel="noopener noreferrer">
                <Navigation className="mr-2 h-4 w-4" /> Get directions
              </a>
            </Button>
          </div>

          <div className="lg:col-span-8">
            <iframe
              title="Map to Priceline Pharmacy Margaret River"
              data-testid="contact-map"
              src={MAP_EMBED}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-[420px] w-full rounded-3xl border border-border/60 shadow-[0_8px_32px_rgba(0,0,0,0.05)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
